import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://wxzufaptjcqbvwfvujpp.supabase.co"
const supabaseKey = "sb_publishable_I5AHqyJc0cNofOTNaTclPg_e4tYbLFe"

export const supabase = createClient(supabaseUrl, supabaseKey)